import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "Tableau de bord",
    moduleName: "dashboard",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "dashboard/admin",
        title: "Admin",
        moduleName: "dashboard",
        iconType: "cog",
        icon: "description",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441066142928796",
        submenu: [],
      },
      {
        path: "dashboard/general",
        title: "Général",
        moduleName: "dashboard",
        iconType: "cog",
        icon: "description",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441066142928796",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Paramètres",
    moduleName: "parametres",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/parametres/systeme",
        title: "Système",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/parametres/divers",
        title: "Divers",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/parametres/production",
        title: "Production",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      {
        path: "/parametres/medical",
        title: "Médical",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052349415453764",
        submenu: [],
      },
      {
        path: "/parametres/sinistre",
        title: "Sinistre",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052349415453764",
        submenu: [],
      },
      {
        path: "/parametres/comptabilite",
        title: "Comptabilité",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052351743258503",
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Sinistre",
    moduleName: "sinistre",
    iconType: "exclamation-triangle",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/sinistre/predecompte-sinistre",
        title: "Pré-décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441066142928796",
        submenu: [],
      },
      {
        path: "/sinistre/decompte",
        title: "Décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441066142928796",
        submenu: [],
      },
      {
        path: "/sinistre/validation-decompte",
        title: "Validation décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441066142928796",
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Administration",
    moduleName: "administration",
    iconType: "lock",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441083453297610",
    submenu: [
      {
        path: "/administration/type-utilisateur",
        title: "Type utilisateur",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs",
        title: "Utilisateurs",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/roles",
        title: "Roles",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441216245876852",
        submenu: [],
      },

      {
        path: "/administration/fonctionnalites",
        title: "Fonctionnalites",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441503140781272",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-prestataires",
        title: "Utilisateurs prestataires",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-garants",
        title: "Utilisateurs garants",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-beneficiaire",
        title: "Utilisateurs beneficiaire",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/configuration",
        title: "Configuration",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },
      {
        path: "/administration/plan",
        title: "Plan",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },
      {
        path: "/administration/souscription",
        title: "Souscription",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },
      {
        path: "/administration/filiale",
        title: "Filiale",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },
      {
        path: "/administration/demandes-vitrine",
        title: "Demandes site vitrine",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },
    ],
  },
];
